import { fmt } from '../../utils/formatters';

export default function InvoiceItemsTableEditable({ items, onUpdateItem, onAddItem, onRemoveItem }) {
  const hasDiscount = items?.some(it => Number(it.discount) > 0);

  return (
    <div className="items-wrap">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '16px 0 8px' }}>
        <span style={{ fontWeight: 600, color: 'var(--ink-soft)', letterSpacing: '0.5px', textTransform: 'uppercase', fontSize: 11 }}>
          LINE ITEMS
        </span>
        <button className="btn btn-sm btn-outline" onClick={onAddItem}>+ Add Row</button>
      </div>

      <table className="items-table">
        <thead>
          <tr>
            <th>Description</th>
            <th>Qty</th>
            <th>Unit Price</th>
            <th>VAT %</th>
            <th>VAT Amount</th>
            {hasDiscount && <th>Discount</th>}
            <th>Total</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {items.map((it, i) => {
            const lineVat = (Number(it.qty) * Number(it.unitPrice)) * (Number(it.vatRate) / 100);
            const lineTotal = Number(it.qty) * Number(it.unitPrice);
            return (
              <tr key={i} className={it.isAutoAdded ? 'auto-item' : ''}>
                <td>
                  <input
                    className="table-input"
                    value={it.description}
                    onChange={e => onUpdateItem(i, 'description', e.target.value)}
                    placeholder="Description..."
                  />
                </td>
                <td>
                  <input
                    className="table-input cell-center"
                    type="number" min="0" step="1"
                    value={it.qty}
                    onChange={e => onUpdateItem(i, 'qty', e.target.value)}
                    style={{ width: 60, textAlign: 'center' }}
                  />
                </td>
                <td>
                  <input
                    className="table-input cell-num"
                    type="number" min="0" step="0.01"
                    value={it.unitPrice}
                    onChange={e => onUpdateItem(i, 'unitPrice', e.target.value)}
                    style={{ width: 80, textAlign: 'right' }}
                  />
                </td>
                <td>
                  <select
                    className="table-input"
                    value={it.vatRate}
                    onChange={e => onUpdateItem(i, 'vatRate', Number(e.target.value))}
                    style={{ textAlign: 'center', width: 65 }}
                  >
                    <option value={0}>0%</option>
                    <option value={20}>20%</option>
                  </select>
                </td>
                <td className="cell-muted">{fmt(lineVat)}</td>
                {hasDiscount && (
                  <td>
                    <input
                      className="table-input cell-num"
                      type="number" min="0" step="0.01"
                      value={it.discount || 0}
                      onChange={e => onUpdateItem(i, 'discount', Number(e.target.value))}
                      style={{ width: 70, textAlign: 'right', color: Number(it.discount) > 0 ? 'var(--danger, #9b2335)' : 'inherit', fontWeight: Number(it.discount) > 0 ? 600 : 400 }}
                    />
                  </td>
                )}
                <td className="cell-gold">{fmt(lineTotal)}</td>
                <td style={{ textAlign: 'center' }}>
                  <button className="btn-icon" onClick={() => onRemoveItem(i)}>×</button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

